export default __webpack_public_path__ + "images/2b9f187980de5370ce17d628f4e610dd-film.jpg";